import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ClientInput from "./FormInputs/ClientInput";
import SellingSpotInput from "./FormInputs/SellingSpotInput";
import SearchInput from "./FormInputs/SearchInput";
import DateFromInput from "./FormInputs/DateFromInput";
import DateToInput from "./FormInputs/DateToInput";
import { useForm } from "react-hook-form";

const SearchForm = ({
  search,
  setSearch,
  pagination,
  setPagination,
  setIsLoading,
}) => {
  const { t: translator } = useTranslation();

  const { control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [stores, setStores] = useState([]);
  return (
    <fieldset className="scheduler-border">
      <legend className="scheduler-border">
        {translator("Documents-List-Filters")}
      </legend>
      <form
        className="row"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <ClientInput
          control={control}
          setSearch={setSearch}
          search={search}
          setStores={setStores}
          setValue={setValue}
        />
        <SellingSpotInput
          stores={stores}
          control={control}
          search={search}
          setSearch={setSearch}
        />
        <SearchInput
          search={search}
          setSearch={setSearch}
          pagination={pagination}
          setPagination={setPagination}
          setIsLoading={setIsLoading}
        />
        <div class="container-fluid row">
          <DateFromInput search={search} setSearch={setSearch} />
          <DateToInput search={search} setSearch={setSearch} />
        </div>

        <div></div>
      </form>
    </fieldset>
  );
};

export default SearchForm;
